"use strict";

// feature_toggle.json からデフォルト設定を読み込み
const fileConfig = require("./feature_toggle.json");

// JSON/環境変数を走査して値テーブルを構築
const toggles = {};

// 1) JSONの値を反映
for (const [key, value] of Object.entries(fileConfig || {})) {
  toggles[key] = !!value;
}

// 2) 環境変数 FEATURE_TOGGLE_JSON の設定で更に上書き
if (typeof process !== "undefined" && process.env && process.env.FEATURE_TOGGLE_JSON) {
  try {
    const envConfig = JSON.parse(process.env.FEATURE_TOGGLE_JSON);
    for (const [key, value] of Object.entries(envConfig || {})) {
      toggles[key] = !!value;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Failed to parse FEATURE_TOGGLE_JSON environment variable:", e);
  }
}

// 既存のnamed exportは維持（未定義キーはfalse扱い）
export const FEATURE_C2C_LIMIT_FIX = !!toggles.FEATURE_C2C_LIMIT_FIX;
export const FEATURE_C2C_MAP_TALK = !!toggles.FEATURE_C2C_MAP_TALK;
export const FEATURE_JKC_LONG_TALK_GROUP = !!toggles.FEATURE_JKC_LONG_TALK_GROUP;
export const FEATURE_JKC_STUN = !!toggles.FEATURE_JKC_STUN;
export const FEATURE_JKC_SETTING_JOINED_GROUP = !!toggles.FEATURE_JKC_SETTING_JOINED_GROUP;
export const FEATURE_JKC_TRACKING_WITH_STATUS = !!toggles.FEATURE_JKC_TRACKING_WITH_STATUS;
export const FEATURE_JKC_EMERGENCY = !!toggles.FEATURE_JKC_EMERGENCY;
export const FEATURE_JKC_C2C_ADMIN_USER_CHANGE = !!toggles.FEATURE_JKC_C2C_ADMIN_USER_CHANGE;
export const FEATURE_DEFERRED_REQUEST = !!toggles.FEATURE_DEFERRED_REQUEST;
export const FEATURE_C2C_AUDIT_LOG = !!toggles.FEATURE_C2C_AUDIT_LOG;
export const FEATURE_CUT_VOICE_DELAY = !!toggles.FEATURE_CUT_VOICE_DELAY;
export const FEATURE_BD_1939_IP_RESTRICTION = !!toggles.FEATURE_BD_1939_IP_RESTRICTION;
export const FEATURE_JKC_SEPARATE_CURRENT_LINE_FROM_PRIMARY_LINE =
  !!toggles.FEATURE_JKC_SEPARATE_CURRENT_LINE_FROM_PRIMARY_LINE;
export const FEATURE_BD_2109_DEVICE_ID_VALIDATION = !!toggles.FEATURE_BD_2109_DEVICE_ID_VALIDATION;
export const FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY =
  !!toggles.FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY;
export const FEATURE_BD_2018_RESERVE_TALK =!!toggles.FEATURE_BD_2018_RESERVE_TALK;
export const FEATURE_BD_2018_RESERVE_TALK_CLIENT_SETTINGS =!!toggles.FEATURE_BD_2018_RESERVE_TALK_CLIENT_SETTINGS;
export const FEATURE_BD_1862_LONG_LIVECAST = !!toggles.FEATURE_BD_1862_LONG_LIVECAST;
